import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'
require('antd/lib/checkbox/style')

const StyledCheckbox = styled(Checkbox)`
  && {
    margin-left: 21px;
    .ant-checkbox {
      margin-left: -21px;
    }
    + .ant-checkbox-wrapper {
      margin-left: 21px;
    }
  }
`
StyledCheckbox.Group = Checkbox.Group
export default StyledCheckbox
